import React, { useState } from 'react';
import FeedbackForm from './FeedbackForm';

const FeedbackButton = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const toggleForm = () => {
    setIsFormOpen(prevState => !prevState);
  };

  return (
    <>
      <button 
        onClick={toggleForm}
        className={`
          fixed bottom-20 right-6 md:bottom-20 md:right-8 z-40
          bg-primary hover:bg-primary-focus text-white
          w-12 h-12 rounded-full shadow-lg
          flex items-center justify-center
          transform transition-all duration-200 hover:scale-105 focus:outline-none
          ${isFormOpen ? 'rotate-45' : ''}
        `}
        aria-label={isFormOpen ? "Fermer le formulaire" : "Ouvrir le formulaire de feedback"}
      >
        {isFormOpen ? (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
          </svg>
        )}
      </button>
      
      <FeedbackForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
};

export default FeedbackButton;
